import React from 'react'
import Lottie from "lottie-react";
import data from "./../lottie/data.json";
import game from "./../lottie/game.json";
import guitar from "./../lottie/guitar.json";
import { motion } from "framer-motion";
const About = () => {
  return (
    
      <div className='flex flex-col h-auto   p-20 w-full '>
    <div class="animate-pulse h-16 w-64 text-left font-bold tracking-widest text-transparent text-3xl bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-700 ">About Me </div>
    <div className=' flex md:flex-row lg:flex-row flex-col'>
    <div className=' w-full'>
    <div className="container mx-auto p-4">
    <h2 className="text-xl font-semibold font-mono mb-4 text-yellow-600 tracking-widest underline underline-offset-4">Education & Certifications</h2>

      <ul className="list-disc list-inside text-justify text-slate-400 tracking-wider font-mono">
        <li>Currently pursuing B.Tech in Computer Science Engineering at Galgotias University (2020-Current).</li>
        <li>Completed +2 from Xavier International College, Nepal (2017-2019).</li>
        <li>Completed schooling from New English Boarding School, Nepal (2016).</li>
        <li>Holds certifications in Database Programming with SQL from Oracle, Introduction to Java Programming by Infosys Springboard, and NDG Linux Certification 1 & 2.</li>
      </ul>
    </div>
    </div>
    <motion.div
    initial={{ x: 400 }}
    animate={{ x: 0,
      transition: { duration: 1.2, ease: 'easeOut' } }}
    className=' w-full'><Lottie className='h-80' animationData={data}/></motion.div>
    </div>
    <div className=' flex md:flex-row lg:flex-row flex-col'>

    <div className='flex md:flex-row lg:flex-row xl:flex-row sm:flex-col'>
      
      <div className=' w-full'><Lottie className='h-80' animationData={game}/></div>
    <div className=' w-full'><Lottie className='h-80' animationData={guitar}/></div>
      
    </div>

    <div className=' w-full'>
    <div className="container mx-auto md:ml-52 lg:ml-72 xl:ml-72 w-3/4 p-4">
      <h2 className="mt-16 text-xl font-semibold font-mono mb-4 text-yellow-600 tracking-widest underline underline-offset-4">Interests</h2>
      <ul className="list-disc list-inside text-justify text-slate-400 tracking-wider font-mono">
        <li>Enjoys reading tech blogs to stay updated with the latest trends and advancements in the field.</li>
        <li>Passionate about playing online games, exploring different game genres, and engaging in multiplayer experiences.</li>
        <li>Skilled in playing the guitar, spending leisure time strumming melodies and exploring different musical genres.</li>
      </ul>
    </div>
    </div>
    
    </div>

    </div>
      
  )
}

export default About